export default function($) {
  const searchTrigger = $('.js-search-button');
  const searchHeader = $('.js-search-header');


  searchTrigger.on('click', function(e) {
    e.preventDefault();

    if( ! $(this).hasClass('open') ) {
      $(this).addClass('open');
      $(this).find('a').html('Fermer');
      searchHeader.css('top', '100%');
      searchHeader.find('input').focus();

    } else {
      $(this).removeClass('open');
      $(this).find('a').html('Rechercher');
      searchHeader.css('top', '-13rem');
    }
  })

  $(window).on('resize', function () {
    if (searchTrigger.hasClass('open')) {
      searchTrigger.removeClass('open');
      searchTrigger.find('a').html('Rechercher');
      searchHeader.css('top', '-13rem');
    }
  });

}
